export interface ThemeColors {
    backgroundColor: string;
    primaryColor: string;
    secondaryColor: string;
    navigationColor: string;
    textColor: string;
    accentColor: string;
    subtleAccent: string;
    borderColor: string;
}

export const DEFAULT_THEME: ThemeColors = {
    backgroundColor: '#ffffff',
    primaryColor: '#2196f3',
    secondaryColor: '#ffffff',
    navigationColor: '#1976d2',
    textColor: '#333333',
    accentColor: '#73b7f0',
    subtleAccent: '#f5f5f5',
    borderColor: '#e0e0e0'
};

// Helper function to get theme value with fallback to default
export const getThemeValue = (
    value: string | null | undefined, 
    defaultKey: keyof ThemeColors
): string => {
    // Return default if value is null, undefined, or empty string
    if (!value || value.trim() === '') {
        return DEFAULT_THEME[defaultKey];
    }
    return value;
}; 